import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const audiobookshelf = defineConnector({
  identifier: "audiobookshelf",
  name: "Audiobookshelf",
  tagLine: "Self-hosted audiobook and podcast server",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Audiobookshelf server URL",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://audiobookshelf.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Audiobookshelf server.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Audiobookshelf, go to your user menu and click **Settings**. Under the **API Token** section, copy your token.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/authorize`,
  },
});
